import { BookOutlined, DownOutlined, FolderOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, DropDownProps, Dropdown, Menu, Tooltip } from 'antd'
import { useAtom } from 'jotai'
// import { useAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

import { routes } from '@/router'

import { userInfoAtom } from '../user'

// import { userInfoAtom } from '../user'

export const CreateDropdown: React.FC<Omit<DropDownProps, 'overlay'>> = (props) => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const [viewer] = useAtom(userInfoAtom)

  const canCreateDevlop =
    viewer.isSuperAdmin || viewer.isMiniIPDCore || viewer.roles.some((r) => r.role === '7_committee')

  const isPersonal = pathname.startsWith('/personal')
  const isCustomerPage = pathname.startsWith('/customer')
  const isProductionPage = pathname.startsWith('/production')
  const isDevlopPage = pathname.startsWith('/devlop')
  const menu = (
    <Menu>
      <Menu.Item key='project-create' icon={<BookOutlined />}>
        <Link to={routes.project.create()}>{t('project.create')}</Link>
      </Menu.Item>
      <Menu.Item key='portfolio-create' icon={<FolderOutlined />}>
        <Link to={routes.portfolio.create()}>{t('portfolio.create')}</Link>
      </Menu.Item>
      {isCustomerPage || isPersonal ? (
        <Menu.Item key='customer-create' icon={<FolderOutlined />}>
          <Link to={routes.customer.create}>{t('customer.createCustomer')}</Link>
        </Menu.Item>
      ) : null}
      {isProductionPage || isPersonal ? (
        <Menu.Item key='production-create' icon={<FolderOutlined />}>
          <Link to={routes.production.create}>{t('production.createProduction')}</Link>
        </Menu.Item>
      ) : null}
      {isDevlopPage || isPersonal ? (
        <Tooltip visible={canCreateDevlop ? false : undefined} title={t('devlop.createDevlopTooltip')}>
          {/*Menu.Item disabled 情况下无法触发 tooltip*/}
          <div>
            <Menu.Item disabled={!canCreateDevlop} key='devlop-create' icon={<FolderOutlined />}>
              <Link to={routes.devlop.create}>{t('devlop.createDevlop')}</Link>
            </Menu.Item>
          </div>
        </Tooltip>
      ) : null}
    </Menu>
  )

  return (
    <Dropdown trigger={['click']} overlay={menu} {...props}>
      <Button type='primary' shape='round' icon={<PlusOutlined />}>
        {t('create')} <DownOutlined />
      </Button>
    </Dropdown>
  )
}
